export const MY_LEARNING_TABS = ['all', 'videos', 'courses-and-lessons', 'playlists'];